module.exports = __webpack_public_path__ + "static/media/hadir.81283cd6.svg";